import React from 'react';
import { Checkbox as MuiCheckbox } from '@material-ui/core';
import { noop } from 'lodash';
import CheckboxFilled from '../../../icons/CheckboxFilled';
import CheckboxIndeterminate from '../../../icons/CheckboxIndeterminate';
import CheckboxEmpty from '../../../icons/CheckboxEmpty';
import useStyles from './Checkbox.styles';

export interface CheckboxProps {
  onChange?: (val: boolean) => void;
  checked?: boolean;
  disabled?: boolean;
  dataQaId?: string;
  indeterminate?: boolean;
  ariaLabel?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange = noop,
  disabled,
  dataQaId,
  indeterminate,
  ariaLabel,
}: CheckboxProps) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    disabled || onChange(event.target.checked);
  };

  return (
    <MuiCheckbox
      onChange={handleChange}
      checked={checked}
      data-qa-id={dataQaId}
      disabled={disabled}
      disableRipple
      color="primary"
      indeterminate={indeterminate}
      inputProps={{ 'aria-label': ariaLabel || 'checkbox' }}
      indeterminateIcon={<CheckboxIndeterminate disabled={disabled} />}
      checkedIcon={<CheckboxFilled disabled={disabled} />}
      icon={<CheckboxEmpty disabled={disabled} />}
      classes={{
        root: classes.root,
      }}
    />
  );
};

export default Checkbox;
